import RightArrowIcon from "@/assets/colorable/right_arrow.svg?react";
import Button from "@/components/Common/Button";
import Modal from "@/components/Common/Modal";
import InviteAmbassadorsContent from "@/components/Common/referral/InviteAmbassadorsContent";
import {ambassadorProgramModalAtom, inviteAmbassadorsModalAtom} from "@/store/jotaiAtoms";
import {useAtom, useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const InviteAmbassadorsModal: FC = () => {
  const {t} = useTranslation(["referral", "common"]);
  const [inviteAmbassadorsModal, setInviteAmbassadorsModal] = useAtom(inviteAmbassadorsModalAtom);
  const setAmbassadorProgramModal = useSetAtom(ambassadorProgramModalAtom);

  const closeModal = () =>
    setInviteAmbassadorsModal(state => {
      state.agencyId = null;
      state.companyId = null;
      state.isOpen = false;
      state.openedFromAmbassadorProgram = false;
    });

  return (
    <Modal
      className="py-10"
      backgroundClassName="max-w-177.5 w-[90vw] max-h-[80vh]"
      customTitleRow={
        <div className="flex items-center gap-3 p-5">
          {inviteAmbassadorsModal.openedFromAmbassadorProgram && (
            <Button
              buttonStyle="White"
              className="size-8 shrink-0"
              onClick={() => {
                const {agencyId, companyId} = inviteAmbassadorsModal;
                closeModal();
                setAmbassadorProgramModal(state => {
                  state.agencyId = agencyId;
                  state.companyId = companyId;
                  state.isOpen = true;
                });
              }}>
              <RightArrowIcon className="text-primary-dark-solid size-3 -scale-x-100" />
            </Button>
          )}
          <div className="flex flex-col gap-2">
            <span className="text-neutral-black text-xl leading-4.5 font-semibold">{t("invite_ambassadors")}</span>
            <span className="text-neutral-black text-sm">{t("invite_ambassadors_description")}</span>
          </div>
        </div>
      }
      onClose={closeModal}
      customBottomRow={<></>}
      shouldLockBodyScroll={false}>
      <InviteAmbassadorsContent
        agencyId={inviteAmbassadorsModal.agencyId}
        companyId={inviteAmbassadorsModal.companyId}
        onSectionChange={section =>
          setInviteAmbassadorsModal(state => {
            state.section = section;
          })
        }
        section={inviteAmbassadorsModal.section}
      />
    </Modal>
  );
};

export default InviteAmbassadorsModal;
